import {ChangeDetectorRef, Component, EventEmitter, forwardRef, HostListener, Inject, Input, Output} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {LeaveBlockable} from './leave.blockable';
import {SessionService} from '../../core/security';
import {InjectOptionDialog} from '../option-dialog/option.dialog.decorator';
import {OptionDialog} from '../option-dialog/option.dialog';

@Component({
    selector: 'tfl-leave-block',
    template: require('./leave.block.teamplate.html')
})
export class LeaveBlockComponent {

    private allowedToGo: boolean = false;
    private nextUrl: string = '';
    private previousUrl: string = ';';

    @Input('componentUrl') componentUrl: string;
    @Output('on-ok-modal') onOkModalEvent: EventEmitter<any> = new EventEmitter<any>();

    @InjectOptionDialog('leave-block-dialog') dialog: OptionDialog;

    constructor(@Inject('LeaveBlockable') private backBloackable: LeaveBlockable,
                @Inject(forwardRef(() => SessionService)) private _sessionService: SessionService,
                private _changeDetectorRef: ChangeDetectorRef,
                private _router: Router) {

        _router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.nextUrl = event.url;
            }
            if (event instanceof NavigationEnd) {
                this.previousUrl = event.url;
            }
        })
    }

    @HostListener('window.popstate')
    onBackPressed() {
        this._router.navigateByUrl(this.previousUrl);
        this._changeDetectorRef.markForCheck();
        history.pushState(null, null, this.componentUrl);
    }

    ngOnDestroy() {
        window.removeEventListener('popstate', null, false);
    }

    public showDialogOnNavigateBlock() {
        this.dialog
            .showConfirmDialog({
                title: 'COMMON.LEAVE_BLOCK.TITLE',
                message: 'COMMON.LEAVE_BLOCK.MESSAGE',
                confirmButtonText: 'COMMON.LEAVE_BLOCK.LEAVE',
                cancelButtonText: 'COMMON.LEAVE_BLOCK.STAY'
            })
            .onConfirmAction(this.handleLeaveAction.bind(this))
            .onCancelAction(this.handleStayAction.bind(this))
    }

    public checkAllowedToGo(): boolean {
        if (this.checkIsRedirectAfterSessionExpired()) {
            return true;
        }
        if (this.nextUrl == this.componentUrl || this.backBloackable.isComponentAllowedToLeave()) {
            return this.allowedToGo = true;
        } else {
            if (this.allowedToGo) {
                this.allowedToGo = false;
                return true;
            } else {
                return false;
            }
        }
    }

    private checkIsRedirectAfterSessionExpired() {
        if (this._sessionService.isSessionExpired()) {
            return true;
        }
    }

    private handleLeaveAction() {
        this.allowedToGo = true;
        this._router.navigateByUrl(this.nextUrl);
        this.onOkModalEvent.emit();
    }

    private handleStayAction() {
        this.allowedToGo = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/leave-block/leave.block.component.ts